import { render } from "./ForecastingPCOPresentation.vue?vue&type=template&id=0cd7c71f&ts=true"
import script from "./ForecastingPCOPresentation.vue?vue&type=script&lang=ts"
export * from "./ForecastingPCOPresentation.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__